import { ExternalLink } from "lucide-react";
import { buttonVariants } from "../../../../../components/ui/button";
import { cn } from "../../../../../lib/utils";

interface SyncedControlHeaderProps {
  controlName: string;
  externalControlUrl: string | null;
}

/**
 * Presentational "SYNCED CONTROL" header used in both steps of the Pull
 * Samples from Optro modal: the linked control's name plus an "Optro ↗"
 * link-out. When `externalControlUrl` is null (malformed system-of-record /
 * external ref) the link is omitted rather than rendering a broken anchor.
 */
export function SyncedControlHeader({
  controlName,
  externalControlUrl,
}: SyncedControlHeaderProps) {
  return (
    <div className="flex items-center justify-between gap-3 rounded-lg border border-stone-200 bg-stone-50/60 px-4 py-3">
      <div className="min-w-0">
        <p className="text-[11px] font-semibold uppercase tracking-wide text-stone-500">
          Synced Control
        </p>
        <p className="mt-0.5 truncate text-sm font-medium text-stone-900">
          {controlName}
        </p>
      </div>
      {externalControlUrl && (
        <a
          href={externalControlUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={cn(
            buttonVariants({ variant: "outline", size: "sm" }),
            "shrink-0 gap-1.5",
          )}
        >
          Optro
          <ExternalLink className="h-3.5 w-3.5" />
        </a>
      )}
    </div>
  );
}
